import { render, staticRenderFns } from "./NavigationFooter.vue?vue&type=template&id=2693b799&scoped=true"
import script from "./NavigationFooter.vue?vue&type=script&lang=ts"
export * from "./NavigationFooter.vue?vue&type=script&lang=ts"
import style0 from "./NavigationFooter.vue?vue&type=style&index=0&id=2693b799&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2693b799",
  null
  
)

export default component.exports